/**
 * לקוח Supabase לדפדפן — עם המפתח הציבורי בלבד.
 *
 * ההגנה על הנתונים היא ה־RLS בשכבת הנתונים, לא הקוד הזה: כל מה שהמסך
 * מסתיר ממשתמש נחסם גם בשרת (נבדק ב־tests/db). אסור שמפתח service_role
 * או sb_secret_ יגיע לכאן — `npm run check:security` נכשל אם יופיע.
 */

import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined;

/**
 * סוג הקישור שהביא את המשתמש (הזמנה / איפוס סיסמה), או שגיאה ממנו.
 * נקרא לפני יצירת הלקוח, כי הלקוח מנקה את ה־hash אחרי שהוא קורא אותו.
 */
function readAuthLink(): { type: string | null; error: string | null } {
  const params = new URLSearchParams(window.location.hash.replace(/^#/, ''));
  return {
    type: params.get('type'),
    error: params.get('error_description') ?? params.get('error'),
  };
}

export const authLink = readAuthLink();

export const supabase: SupabaseClient | null =
  url !== undefined && url !== '' && key !== undefined && key !== ''
    ? createClient(url, key, { auth: { detectSessionInUrl: true, persistSession: true } })
    : null;

export const SITE_FILES_BUCKET = 'site-files';

export function requireClient(): SupabaseClient {
  if (supabase === null) throw new Error('Supabase is not configured');
  return supabase;
}
